import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/simple-interest',
  component: () => import('../../routes/SimpleInterest.svelte'),
  card: {
    id: 'simple-interest',
    title: 'Simple Interest',
    description: 'Calculate simple interest earned on a principal amount. See year-by-year balance growth with the linear interest formula I = P × r × t.',
    icon: 'interest',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/simple-interest',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Simple Interest Calculator – Interest Formula & Year-by-Year Breakdown',
    description: 'Free simple interest calculator. Calculate simple interest earned or owed using the formula I = P × r × t. See year-by-year balance growth with no compounding effect. Compare with compound interest and understand linear interest growth.',
  },
};

export default meta;
